import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { FadeInAnimationComponent } from './components/fade-in-animation.component';

@NgModule({
	imports: [
		CommonModule
	],
	declarations: [
		FadeInAnimationComponent
	],
	exports: [
		FadeInAnimationComponent
	]
})
export class AnimationsModule { }
